"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isFinite = Number.isFinite;
var numeric = exports.numeric = function numeric(key) {
  return function (itemA, itemB) {
    var a = parseFloat(itemA[key]);
    var b = parseFloat(itemB[key]);

    if (!isFinite(a)) return 1;
    if (!isFinite(b)) return -1;

    return b - a;
  };
};

var numericReverse = exports.numericReverse = function numericReverse(key) {
  return function (itemA, itemB) {
    var a = parseFloat(itemA[key]);
    var b = parseFloat(itemB[key]);

    if (!isFinite(a)) return 1;
    if (!isFinite(b)) return -1;

    return a - b;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/sorting/compareFns/numeric.js
// module id = 2282
// module chunks = 0